export default __webpack_public_path__ + "static/media/1213 spice rack side.adf05d8e.png";